import { apiClient, handleResponse } from './axios';

export async function getStudents() {
  try {
    const response = await apiClient.get('/dendreo/student');
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getStudentsCourses(dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/student/${dendreoId}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getTeachers() {
  try {
    const response = await apiClient.get('/dendreo/teacher');
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getTeachersCourses(dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/teacher/${dendreoId}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getAdfCourses(dendreoAdfId) {
  try {
    const response = await apiClient.get(`/dendreo/adf/creneaux/${dendreoAdfId}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getDendreoCompanies(inputValue) {
  try {
    const response = await apiClient.get(`/dendreo/companies?search=${inputValue}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}
export async function getAdfByDendreoCompanies(companyId, inputValue) {
  try {
    const response = await apiClient.get(`/dendreo/companies/${companyId}/adfs?search=${inputValue}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getLearnerPresencesSummary(idActionDeFormation, dendreoId) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}/participants/${dendreoId}/presences`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function getParticipantActionsFormation(idParticipant) {
  try {
    const response = await apiClient.get(`/dendreo/adf/participant/${idParticipant}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function downloadParticipantFormationEmargement(idActionDeFormation, idParticipant) {
  try {
    const response = await apiClient.get(`/dendreo/adf/pdf-participant/${idActionDeFormation}/${idParticipant}`,
      {
        responseType: 'blob',
      });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getActionFormationDetails(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}

export async function downloadAdfEmargement(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/pdf-adf/${idActionDeFormation}`,
      {
        responseType: 'blob',
      });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getAdfSatisfaction(idActionDeFormation) {
  try {
    const response = await apiClient.get(`/dendreo/adf/${idActionDeFormation}/satisfaction`);
    const dendreoRes = await handleResponse(response);
    return dendreoRes;
  } catch (err) {
    return err.response;
  }
}
